// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__+PytG","loader":"LoadingSpinner_loader__kJlEd","l7-0":"LoadingSpinner_l7-0__Wx-vr","l7-1":"LoadingSpinner_l7-1__bnh9S"};